import paymentStatusSlice from "./paymentStatusSlice";
const fineActions = paymentStatusSlice.actions;
export const { setPaymentStatus } = fineActions;
